import { Link } from "react-router-dom";

interface ThankYouProps {
  onReset: () => void;
}

/**
 * Replaces the brief form on successful submission. José's voice, with
 * the actual reply-time commitment from the constitution. Gives visitors
 * a clear "what next" — back to the cube — without trapping them.
 */
export function ThankYou({ onReset }: ThankYouProps) {
  return (
    <div className="flex flex-col gap-5 rounded-2xl border border-jg-mobile/30 bg-jg-mobile/5 p-6 sm:p-8">
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-jg-mobile">
        Brief sent
      </p>
      <h2 className="font-display text-2xl font-semibold leading-tight tracking-tight sm:text-3xl">
        Got it — thanks for the detail.
      </h2>
      <p className="text-sm leading-relaxed text-jg-fg-muted">
        João reads every brief and typically replies within 24h with either
        a scoping question or a calendar link. If it's urgent, the email
        joao@jgson.net goes straight to his inbox.
      </p>
      <div className="flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="rounded-full bg-jg-fg px-4 py-2 text-center text-sm font-semibold text-jg-bg transition-opacity hover:opacity-90"
        >
          Back to the cube
        </Link>
        <button
          type="button"
          onClick={onReset}
          className="rounded-full border border-jg-border bg-jg-bg-soft/60 px-4 py-2 text-sm font-medium text-jg-fg-muted hover:text-jg-fg"
        >
          Send another brief
        </button>
      </div>
    </div>
  );
}
